'use client';

import { PropsWithChildren } from 'react';

import WysiwygString from '~/components/molecules/WysiwygString';

import CheckboxInput, { CheckboxInputProps } from '../atoms/CheckboxInput';

type CheckboxProps = CheckboxInputProps &
  PropsWithChildren & {
    html?: string;
  };

const Checkbox: React.FC<CheckboxProps> = ({
  name,
  id,
  required,
  children,
  html,
}) => {
  if (children || html) {
    return (
      <label className="flex items-start gap-1">
        <CheckboxInput
          className="-mt-1"
          name={name}
          id={id}
          required={required}
        />

        {children && <div className="text-sm">{children}</div>}
        {html && (
          <div className="text-sm [&_a]:underline">
            <WysiwygString html={html} />
          </div>
        )}
      </label>
    );
  }

  return <CheckboxInput name={name} id={id} />;
};

export default Checkbox;
